import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { GlobalLoading } from "./components/GlobalLoading";
import { RouteErrorPage } from "./components/RouteErrorPage";
import { routeTree } from "./routeTree.gen";

export function getRouter() {
  const queryClient = new QueryClient();

  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPendingComponent: () => <GlobalLoading label="Opening your next page" />,
    defaultErrorComponent: RouteErrorPage,
    defaultPendingMs: 0,
    defaultPendingMinMs: 300,
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
